module.exports = __webpack_public_path__ + "img/horizontal_4_7_8011.8d386e82.png";